import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import store from '../../../store';
import preloadVideos from '../../../utils/scripts/preloadVideo';
import preloadImg from '../../../utils/scripts/preloadImg';
import steps from '../../../survey/steps';
import questions from '../../../survey/questions';
import s from './index.module.scss';
import common from '../../index.module.scss';
import video0 from './media/0.mp4';
import video1 from './media/1.mp4';
import video2 from './media/2.mp4';
import video3 from './media/3.mp4';
import video0Male from './media/0_male.mp4';
import video1Male from './media/1_male.mp4';
import video2Male from './media/2_male.mp4';
import video3Male from './media/3_male.mp4';
import poster0 from './media/posters/0.jpg';
import poster1 from './media/posters/1.jpg';
import poster2 from './media/posters/2.jpg';
import poster3 from './media/posters/3.jpg';
import poster0Male from './media/posters/0_male.jpg';
import poster1Male from './media/posters/1_male.jpg';
import poster2Male from './media/posters/2_male.jpg';
import poster3Male from './media/posters/3_male.jpg';

window.addEventListener('load', () => {
	if (store.getState().steps.config === 'long') {
		if (store.getState().global.initialGender === 'female') {
			preloadVideos(video0, video1, video2, video3);
			preloadImg(poster0, poster1, poster2, poster3);
		}

		if (store.getState().global.initialGender === 'male') {
			preloadVideos(video0Male, video1Male, video2Male, video3Male);
			preloadImg(poster0Male, poster1Male, poster2Male, poster3Male);
		}
	}
});

function WorkoutsPreferences (props) {
	const { T } = useT();
	const videos = {
		video0: {
			female: {
				src: video0,
				title: window.locales.exercise_0,
				poster: poster0
			},
			male: {
				src: video0Male,
				title: window.locales.exercise_0_male,
				poster: poster0Male
			}
		},
		video1: {
			female: {
				src: video1,
				title: window.locales.exercise_1,
				poster: poster1
			},
			male: {
				src: video1Male,
				title: window.locales.exercise_1_male,
				poster: poster1Male
			}
		},
		video2: {
			female: {
				src: video2,
				title: window.locales.exercise_2,
				poster: poster2
			},
			male: {
				src: video2Male,
				title: window.locales.exercise_2_male,
				poster: poster2Male
			}
		},
		video3: {
			female: {
				src: video3,
				title: window.locales.exercise_3,
				poster: poster3
			},
			male: {
				src: video3Male,
				title: window.locales.exercise_3_male,
				poster: poster3Male
			}
		}
	};

	const currentStep = useSelector(state => state.steps.currentStep);
	const gender = questions.getAnswers({ questionName: 'gender' }).value;
	let currentVideo = 0;

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'workouts_preferences',
			stepStatus: true
		});
	});

	function actionOnClick (e) {
		e.target.classList.add(`${s.animate}`);

		setTimeout(() => {
			e.target.classList.remove(`${s.animate}`);
		}, 150);

		if (currentVideo >= 3) {
			steps.navigate.forward({ preventAction: 0 });
			currentVideo = 0;

			document.querySelectorAll(`.${s.subVideoWrapper}`).forEach(el => el.classList.remove(s.show));

			return;
		}

		++currentVideo;
		document.querySelectorAll(`.${s.subVideoWrapper} video`).forEach(el => el.pause());
		document.querySelector(`.${s.subVideoWrapper}[data-video="${currentVideo}"] video`).play();
		document.querySelector(`.${s.subVideoWrapper}[data-video="${currentVideo}"]`).classList.add(s.show);
	}

	useEffect(() => {
		if (!props.isThisCurrentStep) {
			document.querySelector(`.${s.subVideoWrapper}[data-video="${currentVideo}"] video`).pause();
		}
	}, [currentStep]);

	function onWaiting (e) {
		e.target.parentNode.classList.add(s.showLoader);
	}

	function onPlaying (e) {
		e.target.parentNode.classList.remove(s.showLoader);
	}

	const videoTwo = useRef(null);
	const videoThree = useRef(null);
	const videoFour = useRef(null);

	return (
		<div className={common.step}>
			<h1 className={common.stepTitle}>{T('workouts_preferences')}</h1>
			<div className={common.stepDescription}>{T('workouts_preferences_description')}</div>
			<div className={s.videoWrapper}>
				<div className={s.subVideoWrapper} data-video="0">
					<div className={s.loader} />
					<div className={s.videoName} dangerouslySetInnerHTML={{ __html: videos.video0[gender].title }} />
					<video
						id="workoutsPreferenciesVideo"
						className={`${s.video} ${s.video_0}`}
						muted
						loop
						playsInline
						preload="auto"
						poster={videos.video0[gender].poster}
						onWaiting={e => {
							onWaiting(e);
						}}
						onPlaying={e => {
							onPlaying(e);
						}}
					>
						<source src={`${videos.video0[gender].src}#t=0.0001`} type="video/mp4" />
					</video>
				</div>
				<div className={s.subVideoWrapper} data-video="1">
					<div className={s.loader} />
					<div className={s.videoName} dangerouslySetInnerHTML={{ __html: videos.video1[gender].title }} />
					<video
						ref={videoTwo}
						className={`${s.video} video_1 ${s.video_1}`}
						muted
						loop
						playsInline
						preload="auto"
						poster={videos.video1[gender].poster}
						onWaiting={e => {
							onWaiting(e);
						}}
						onPlaying={e => {
							onPlaying(e);
						}}
					>
						<source src={`${videos.video1[gender].src}#t=0.0001`} type="video/mp4" />
					</video>
				</div>
				<div className={s.subVideoWrapper} data-video="2">
					<div className={s.loader} />
					<div className={s.videoName} dangerouslySetInnerHTML={{ __html: videos.video2[gender].title }} />
					<video
						ref={videoThree}
						className={`${s.video} video_2 ${s.video_2}`}
						muted
						loop
						playsInline
						preload="auto"
						poster={videos.video2[gender].poster}
						onWaiting={e => {
							onWaiting(e);
						}}
						onPlaying={e => {
							onPlaying(e);
						}}
					>
						<source src={`${videos.video2[gender].src}#t=0.0001`} type="video/mp4" />
					</video>
				</div>
				<div className={s.subVideoWrapper} data-video="3">
					<div className={s.loader} />
					<div className={s.videoName} dangerouslySetInnerHTML={{ __html: videos.video3[gender].title }} />
					<video
						ref={videoFour}
						className={`${s.video} video_3 ${s.video_3}`}
						muted
						loop
						playsInline
						preload="auto"
						poster={videos.video3[gender].poster}
						onWaiting={e => {
							onWaiting(e);
						}}
						onPlaying={e => {
							onPlaying(e);
						}}
					>
						<source src={`${videos.video3[gender].src}#t=0.0001`} type="video/mp4" />
					</video>
				</div>
			</div>
			<div className={s.actions}>
				<button onClick={actionOnClick} className={s.action} type="button">
					<span className={s.symbol}>❌</span>
					<span className={s.actionName}>{T('hate')}</span>
				</button>
				<button onClick={actionOnClick} className={s.action} type="button">
					<span className={s.symbol}>🙂</span>
					<span className={s.actionName}>{T('neutral')}</span>
				</button>
				<button onClick={actionOnClick} className={s.action} type="button">
					<span className={s.symbol}>❤️</span>
					<span className={s.actionName}>{T('love')}</span>
				</button>
			</div>
		</div>
	);
}

export default WorkoutsPreferences;
